import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AlertDialogData {
    title: string;
    isHtmlContent: boolean;
    isDashboardDesc: boolean;
    content: string;
    closeButton: string;
    actionAlign: string;
}

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.css'],
    encapsulation: ViewEncapsulation.None,
})

export class AlertDialogComponent implements OnInit {
    title = "Alert";
    isHtmlContent = false;
    isTrans = false;
    isDashboardDesc = false;
    content = '';
    closeButton = 'Close';
    actionAlign = 'end';
    html: SafeHtml | undefined;
    dataSource: any;

    constructor(
        public dialogRef: MatDialogRef<AlertDialogComponent>,
        private sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: AlertDialogData) {
        if (data && data.title) {
            this.title = data.title;
        } 
        
        if (data && data.isHtmlContent) {
            this.isHtmlContent = data.isHtmlContent;
            this.html = this.sanitizer.bypassSecurityTrustHtml(data.content);
        } 
        
        if (data && data.content) {
            this.content = data.content;
        } 
        
        if (data && data.closeButton) {
            this.closeButton = data.closeButton;
        } 
        
        if (data && data.actionAlign) {
            this.actionAlign = data.actionAlign;
        }

        if (data.isDashboardDesc) {
            this.isDashboardDesc = data.isDashboardDesc;
        }
    }

    ngOnInit(): void {
    }
}
